import apiService from './ApiService';

const buildQuery = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, value);
    }
  });
  return query.toString();
};

class CtaCteApiService {
  login(email, password) {
    return apiService.postPublic('/ctacte/auth/login', { email, password });
  }

  getCostoSuscripcion() {
    return apiService.get('/ctacte/auth/costo-suscripcion');
  }

  register(payload) {
    return apiService.postPublic('/ctacte/auth/register', payload);
  }

  getResumen() {
    return apiService.get('/ctacte/resumen');
  }

  getEtiquetas(params = {}) {
    const query = buildQuery(params);
    return apiService.get(`/ctacte/etiquetas${query ? `?${query}` : ''}`);
  }

  createEtiqueta(payload) {
    return apiService.post('/ctacte/etiquetas', payload);
  }

  updateEtiqueta(id, payload) {
    return apiService.put(`/ctacte/etiquetas/${encodeURIComponent(id)}`, payload);
  }

  deleteEtiqueta(id) {
    return apiService.delete(`/ctacte/etiquetas/${encodeURIComponent(id)}`);
  }

  deleteEtiquetaPermanently(id) {
    return apiService.delete(`/ctacte/etiquetas/${encodeURIComponent(id)}/permanente`);
  }

  getCuentas() {
    return apiService.get('/ctacte/cuentas');
  }

  suggestCuentaCode() {
    return apiService.get('/ctacte/cuentas/sugerir-codigo');
  }

  createCuenta(payload) {
    return apiService.post('/ctacte/cuentas', payload);
  }

  updateCuenta(id, payload) {
    return apiService.put(`/ctacte/cuentas/${encodeURIComponent(id)}`, payload);
  }

  deleteCuenta(id) {
    return apiService.delete(`/ctacte/cuentas/${encodeURIComponent(id)}`);
  }

  createSubcuenta(cuentaId, payload) {
    return apiService.post(`/ctacte/cuentas/${encodeURIComponent(cuentaId)}/subcuentas`, payload);
  }

  suggestSubcuentaCode(cuentaId) {
    return apiService.get(`/ctacte/cuentas/${encodeURIComponent(cuentaId)}/subcuentas/sugerir-codigo`);
  }

  updateSubcuenta(cuentaId, id, payload) {
    return apiService.put(`/ctacte/cuentas/${encodeURIComponent(cuentaId)}/subcuentas/${encodeURIComponent(id)}`, payload);
  }

  deleteSubcuenta(cuentaId, id) {
    return apiService.delete(`/ctacte/cuentas/${encodeURIComponent(cuentaId)}/subcuentas/${encodeURIComponent(id)}`);
  }

  getMovimientos(filters = {}) {
    const query = buildQuery(filters);
    return apiService.get(`/ctacte/movimientos${query ? `?${query}` : ''}`);
  }

  createMovimiento(payload) {
    return apiService.post('/ctacte/movimientos', payload);
  }

  updateMovimiento(id, payload) {
    return apiService.put(`/ctacte/movimientos/${encodeURIComponent(id)}`, payload);
  }

  deleteMovimiento(id) {
    return apiService.delete(`/ctacte/movimientos/${encodeURIComponent(id)}`);
  }

  getTiposComprobante(params = {}) {
    const query = buildQuery(params);
    return apiService.get(`/ctacte/tipos-comprobante${query ? `?${query}` : ''}`);
  }

  createTipoComprobante(payload) {
    return apiService.post('/ctacte/tipos-comprobante', payload);
  }

  updateTipoComprobante(id, payload) {
    return apiService.put(`/ctacte/tipos-comprobante/${encodeURIComponent(id)}`, payload);
  }

  deleteTipoComprobante(id) {
    return apiService.delete(`/ctacte/tipos-comprobante/${encodeURIComponent(id)}`);
  }

  getClientes(params = {}) {
    const query = buildQuery(params);
    return apiService.get(`/ctacte/clientes${query ? `?${query}` : ''}`);
  }

  createCliente(payload) {
    return apiService.post('/ctacte/clientes', payload);
  }

  updateCliente(id, payload) {
    return apiService.put(`/ctacte/clientes/${encodeURIComponent(id)}`, payload);
  }

  deleteCliente(id) {
    return apiService.delete(`/ctacte/clientes/${encodeURIComponent(id)}`);
  }

  getProveedores(params = {}) {
    const query = buildQuery(params);
    return apiService.get(`/ctacte/proveedores${query ? `?${query}` : ''}`);
  }

  createProveedor(payload) {
    return apiService.post('/ctacte/proveedores', payload);
  }

  updateProveedor(id, payload) {
    return apiService.put(`/ctacte/proveedores/${encodeURIComponent(id)}`, payload);
  }

  deleteProveedor(id) {
    return apiService.delete(`/ctacte/proveedores/${encodeURIComponent(id)}`);
  }

  getComprobantes(filters = {}) {
    const query = buildQuery(filters);
    return apiService.get(`/ctacte/comprobantes${query ? `?${query}` : ''}`);
  }

  createComprobante(payload) {
    return apiService.post('/ctacte/comprobantes', payload);
  }

  updateComprobante(id, payload) {
    return apiService.put(`/ctacte/comprobantes/${encodeURIComponent(id)}`, payload);
  }

  deleteComprobante(id) {
    return apiService.delete(`/ctacte/comprobantes/${encodeURIComponent(id)}`);
  }

  createReporte(payload) {
    return apiService.post('/ctacte/reportes', payload);
  }

  getProcesos(filters = {}) {
    const query = buildQuery(filters);
    return apiService.get(`/ctacte/procesos${query ? `?${query}` : ''}`);
  }

  getProceso(id) {
    return apiService.get(`/ctacte/procesos/${encodeURIComponent(id)}`);
  }

  downloadProceso(id, formato, fileName) {
    return apiService.download(
      `/ctacte/procesos/${encodeURIComponent(id)}/descargar/${encodeURIComponent(formato)}`,
      fileName
    );
  }

  getSuscripcion() {
    return apiService.get('/ctacte/pagos/suscripcion');
  }

  getPagos(filters = {}) {
    const query = buildQuery(filters);
    return apiService.get(`/ctacte/pagos${query ? `?${query}` : ''}`);
  }
}

const ctaCteApiService = new CtaCteApiService();
export default ctaCteApiService;
